import {SizeConfiguratorFilterOptionsStoreClass} from './base';
import Dispatcher from '../../dispatcher';
import ACTION_TYPES from '../../constants/action_types';
import FilterOptionsConstants from '../../constants/filter_options_contants';

class TyreSizeConfiguratorFilterOptionsStoreClass extends SizeConfiguratorFilterOptionsStoreClass {
    reduce(state, {source, action}) {
        let change = false;
        if (ACTION_TYPES.TYRE_SIZE_CONFIGURATOR_FILTER_OPTIONS_ACTION === source) {
            switch (action.type) {
                case FilterOptionsConstants.LOAD_TYRE_FILTER_OPTIONS_ACTION:
                    Object.keys(action.payload).forEach(
                        (key) => {
                            if (typeof state[key] !== 'undefined') {
    
                                change = true;
                                state[key] = action.payload[key];
                            }
                        }
                    );
                    if (change) {
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const TyreSizeConfiguratorFilterOptionsStore = new TyreSizeConfiguratorFilterOptionsStoreClass(Dispatcher);
export default TyreSizeConfiguratorFilterOptionsStore;
